module.exports = __webpack_public_path__ + "img/icoFacturacioFi.f62c9266.png";